import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { learningCollectionsUrl } from '../../../../ClientRoutes';
import BreadCrumbSeparatorIcon from '../../../Cutesies/BreadCrumbSeparatorIcon';
import { T } from '../../../../Translations';

interface Props {
  learningCollectionName: string;
}

const BreadCrumbs: React.FC<Props> = ({ learningCollectionName }) => (
  <div className={'mb-7 flex'}>
    <NavLink
      to={learningCollectionsUrl}
      className={clsx(
        'text-sm text-teal-800 hover:underline hover:decoration-teal-800',
        'hover:decoration-2 hover:underline-offset-4',
      )}
    >
      <T kind="Learning Collections" />
    </NavLink>
    <span className="mr-3 ml-3 mt-0.5">
      <BreadCrumbSeparatorIcon />
    </span>
    <span className="text-sm">{learningCollectionName}</span>
  </div>
);

export default observer(BreadCrumbs);
